module.exports = __webpack_public_path__ + "static/media/picture-(204).d019717a.JPG";